import { PoolCalculateByPolicy } from "constants/company/PoolCalculateByPolicy";

export const PoolCalculateByDroOpts = () => {

    const getPoolCalculateByItemList = (operatingUnit: string) => {
        let items = [];
        if (operatingUnit === 'AQCT' || operatingUnit === 'OICT' || operatingUnit === 'HPJZ' || operatingUnit === 'RSCT') {
            items.push(PoolCalculateByPolicy.DAYS_14);
            items.push(PoolCalculateByPolicy.DAYS_30);
        }
        items.push(PoolCalculateByPolicy.DAILY);
        items.push(PoolCalculateByPolicy.MONTHLY);

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }


    return {
        getPoolCalculateByItemList
    }
}